var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('h3',{staticClass:"block-title"},[_vm._v(_vm._s(_vm.blockTitle))]),_c('div',{staticClass:"slot"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }